export const USER_ROLE = {
  doctor: 'DOCTOR',
  admin: 'ESSILORADMIN',
  mediator: 'MEDIATOR'
}

export const USER_ROLE_REQUESTS_PATH = {
  [USER_ROLE.doctor]: 'compliance/request',
  [USER_ROLE.admin]: 'essiloradmin/request',
  [USER_ROLE.mediator]: 'compliance/request/mediation'
}